var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 2.25C16.0177 2.25 13.5 4.76775 13.5 7.875C13.5 8.496 14.004 9 14.625 9H40.5V40.5H15.75C14.508 40.5 13.5 41.508 13.5 42.75V46.125C13.5 49.2323 16.0177 51.75 19.125 51.75H39.375C42.4823 51.75 45 49.2323 45 46.125V7.875C45 4.76775 42.4823 2.25 39.375 2.25H19.125ZM15.75 13.5C11.925 13.5 9 16.425 9 20.25V22.5C7.65 22.5 6.75 23.4 6.75 24.75V33.75C6.75 35.1 7.65 36 9 36H22.5C23.85 36 24.75 35.1 24.75 33.75V24.75C24.75 23.4 23.85 22.5 22.5 22.5V20.25C22.5 16.425 19.575 13.5 15.75 13.5ZM15.75 16.875C17.55 16.875 19.125 18.45 19.125 20.25V22.5H12.375V20.25C12.375 18.45 13.95 16.875 15.75 16.875ZM29.25 42.4688C30.6495 42.4688 31.7812 43.6005 31.7812 45C31.7812 46.3995 30.6495 47.5312 29.25 47.5312C27.8505 47.5312 26.7188 46.3995 26.7188 45C26.7188 43.6005 27.8505 42.4688 29.25 42.4688Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfa);
export default __webpack_public_path__ + "static/media/mfa.1a1aa02cc016260e02eaa07f7e250c90.svg";
export { ForwardRef as ReactComponent };